import apis from "./index";

/**
 * Creates a single user via JSON payload.
 * 
 * @param {Object} userData 
 * @param {string} token 
 * @returns {Promise<any>}
 */
export const createSingleUser = async (userData, token) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(apis.createUser.single, {
      method: 'POST',
      headers,
      body: JSON.stringify(userData),
    });

    const responseText = await response.text();
    if (!response.ok) {
      throw new Error(responseText || `Failed to create user (${response.status})`);
    }

    try {
      return JSON.parse(responseText);
    } catch (e) {
      return responseText;
    }
  } catch (error) {
    console.error("createSingleUser()::API::Error", error);
    throw error;
  }
};

/**
 * Uploads a CSV file for bulk user creation.
 * 
 * @param {File} csvFile 
 * @param {string} token 
 * @returns {Promise<any>}
 */
export const bulkUploadUsers = async (csvFile, token) => {
  try {
    const formData = new FormData();
    formData.append("file", csvFile);

    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(apis.createUser.bulk, {
      method: 'POST',
      headers,
      body: formData,
    });

    const responseText = await response.text();
    let parsedData = null;
    let isJson = false;
    try {
      parsedData = JSON.parse(responseText);
      isJson = true;
    } catch (e) {
      // not JSON
    }

    if (!response.ok) {
      if (isJson && parsedData && (parsedData.successCount !== undefined || parsedData.failedCount !== undefined)) {
        return parsedData;
      }
      throw new Error(responseText || `Failed to upload bulk users (${response.status})`);
    }

    return isJson ? parsedData : responseText;
  } catch (error) {
    console.error("bulkUploadUsers()::API::Error", error);
    throw error;
  }
};
